import React from 'react';
import { Grid, TextField, Checkbox, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { CheckBoxOutlineBlank } from '@material-ui/icons';

const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const RestaurantGroupSelector = ({
  userGroups,
  restaurantGroups,
  restaurantSubGroups,
  restaurantStores,
  setRestaurantGroups,
  setRestaurantSubGroups,
  setRestaurantStores,
  invalidFields,
  setHasChanged,
  onlyView = false,
  showOnlySubGroups = false
}) => {
  const handleGroupsChange = (_, value) => {
    setRestaurantGroups(value);
    setHasChanged && setHasChanged(true);

    const validSubGroups = restaurantSubGroups.filter((sg) =>
      value.some((group) => group.subGroups.some((gsg) => gsg.id === sg.id))
    );

    setRestaurantSubGroups(validSubGroups);

    const validStores = restaurantStores.filter((store) =>
      validSubGroups.some((sg) => sg.stores.some((s) => s.id === store.id))
    );

    setRestaurantStores(validStores);
  };

  const handleSubGroupsChange = (_, value) => {
    setRestaurantSubGroups(value);
    setHasChanged && setHasChanged(true);

    if (showOnlySubGroups) {
      const allStores = value.reduce((acc, sg) => [...acc, ...sg.stores], []);
      setRestaurantStores(allStores);
    } else {
      const validStores = restaurantStores.filter((store) =>
        value.some((sg) => sg.stores.some((s) => s.id === store.id))
      );
      setRestaurantStores(validStores);
    }
  };

  const handleStoresChange = (_, value) => {
    setRestaurantStores(value);
    setHasChanged && setHasChanged(true);
  };

  return (
    <>
      {/* Grupos */}
      {!showOnlySubGroups && (
        <Grid item xs={4}>
          <Autocomplete
            multiple
            className={`autocompleteSmall backgroundInput ${
              invalidFields?.group && 'labelError'
            }`}
            limitTags={1}
            options={userGroups.groups}
            disableCloseOnSelect
            size="small"
            value={restaurantGroups}
            getOptionLabel={(option) => option.name}
            disabled={onlyView}
            onChange={handleGroupsChange}
            renderOption={(option, { selected }) => (
              <>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8, padding: 0 }}
                  checked={selected}
                />

                <Typography className="fontSizeDefault">
                  {option.name}
                </Typography>
              </>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Grupos*"
                placeholder="Grupos"
                InputLabelProps={{
                  style: { fontFamily: 'Lato', fontSize: '12px' }
                }}
              />
            )}
          />
        </Grid>
      )}

      {/* Subgrupos */}
      <Grid item xs={showOnlySubGroups ? 12 : 4}>
        <Autocomplete
          multiple
          className={`autocompleteSmall backgroundInput ${
            invalidFields?.subGroups && 'labelError'
          }`}
          limitTags={1}
          options={restaurantGroups
            .reduce((acc, group) => [...acc, group.subGroups], [])
            .flat()}
          value={restaurantSubGroups}
          disableCloseOnSelect
          size="small"
          getOptionLabel={(option) => option.name}
          getOptionSelected={(option, value) => option.id === value.id}
          disabled={onlyView}
          onChange={handleSubGroupsChange}
          renderOption={(option, { selected }) => (
            <>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8, padding: 0 }}
                checked={selected}
              />

              <Typography className="fontSizeDefault">{option.name}</Typography>
            </>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Subgrupos*"
              placeholder="Subgrupos"
              InputLabelProps={{
                style: { fontFamily: 'Lato', fontSize: '12px' }
              }}
            />
          )}
        />
      </Grid>

      {/* Restaurantes */}
      {!showOnlySubGroups && (
        <Grid item xs={4}>
          <Autocomplete
            multiple
            className={`autocompleteSmall backgroundInput ${
              invalidFields?.stores && 'labelError'
            }`}
            limitTags={1}
            options={restaurantSubGroups
              .reduce((acc, subGroup) => [...acc, subGroup.stores], [])
              .flat()}
            value={restaurantStores}
            disableCloseOnSelect
            size="small"
            getOptionLabel={(option) => option.name}
            getOptionSelected={(option, value) => option.id === value.id}
            disabled={onlyView}
            onChange={handleStoresChange}
            renderOption={(option, { selected }) => (
              <>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8, padding: 0 }}
                  checked={selected}
                />

                <Typography className="fontSizeDefault">
                  {option.name}
                </Typography>
              </>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Restaurantes*"
                placeholder="Restaurantes"
                InputLabelProps={{
                  style: { fontFamily: 'Lato', fontSize: '12px' }
                }}
              />
            )}
          />
        </Grid>
      )}
    </>
  );
};

export default RestaurantGroupSelector;
